import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebsiteContainerModel } from '../../../../../../models/aggregates/cms/website';
import { ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({providedIn: 'root'})

export class WebsiteService extends BaseApiPublicLoginTemplateService<WebsiteContainerModel, WebsiteContainerModel, WebsiteContainerModel> {
  static readonly WEBSITES_SUB_PATH = 'websites/';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + WebsiteService.WEBSITES_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'websites';
    this.httpClient = http;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'websites';
    // this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + WebsiteService.WEBSITES_SUB_PATH;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + WebsiteService.WEBSITES_SUB_PATH + BaseApiTemplateService.PUBLIC_EP;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + WebsiteService.WEBSITES_SUB_PATH + BaseApiTemplateService.LOGIN_ENTITY_EP;
  }

  updateImage(formData: FormData, imageGuid, visa: ApiVisa) {
    let url = this.apiUrl + '/replace-file/' + imageGuid;
    console.log(this.apiUrl + 'photo', formData);
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url + this.endpoint_path + '/replace-file/' + imageGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  uploadImage(formData: FormData, extGuid, visa: ApiVisa, websidefiletype) {
    let url = this.apiUrl + '/add-files/' + extGuid;
    console.log(this.apiUrl + 'photo', formData);
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/add-files/' + extGuid;
      if (websidefiletype) {
        url += '?' + 'websitefiletype=' + websidefiletype;
      }
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }
}

